import { createContext, useReducer } from "react";
import axios from "axios";
import { API_URL_FIXTURE } from "../../utils/apiURL";

export const fixtureContext = createContext();

const INTIAL_STATE = {
  planogram: [],
  error: null,
  loading: false,
  token: null,
  fixtSingleRow: [],
  rowdelfixt: null,
  planoSingleRow: [],
  rowdelplano: null,
  assortPlano: [],
  getplano: [],
  planogFix: null,
  savePlanog: {},
  onlyplano: []
};

const fixtureReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case "Excel_success":
      return {
        ...state,
        loading: false,
        planogram: payload,
      };
    case "Excel_fail":
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case "Add_success":
      return {
        ...state,
        loading: false,
        planogFix: payload,
      };
    case "Add_fail":
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case "Delete_success":
      return {
        ...state,
        loading: false,
        rowdelfixt: payload,
      };
    case "Delete_fail":
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case "Single_success":
      return {
        ...state,
        loading: false,
        fixtSingleRow: payload,
      };
    case "Single_fail":
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case "SubmitPl_success":
      return {
        ...state,
        loading: false,
        assortPlano: payload,
      };
    case "SubmitPl_fail":
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case "savePl_success":
      return {
        ...state,
        loading: false,
        savePlanog: payload,
      };
    case "savePl_fail":
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case "FetchPl_success":
      return {
        ...state,
        loading: false,
        getplano: payload,
      };
    case "FetchPl_fail":
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case "FetchOn_success":
      return {
        ...state,
        loading: false,
        onlyplano: payload,
      };
    case "FetchOn_fail":
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case "DeletePl_success":
      return {
        ...state,
        loading: false,
        rowdelplano: payload,
      };
    case "DeletePl_fail":
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case "SinglePl_success":
      return {
        ...state,
        loading: false,
        planoSingleRow: payload,
      };
    case "SinglePl_fail":
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
};

export const FixtureContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(fixtureReducer, INTIAL_STATE);

  const fetchExcelFixtureAction = async (tokenVal) => {
    try {
      //header
      const config = {
        headers: {
          Authorization: `Bearer ${tokenVal}`,
          "Content-Type": "application/json;charset=utf-8",
          "Access-Control-Allow-Origin": "*",
          "cache-control": "no-cache",
        },
      };

      const res = await axios.get(
        `${API_URL_FIXTURE}/GetAllPlanogramsFixtures`, config
      );

      if (res?.request.status === 200) {
        dispatch({
          type: "Excel_success",
          payload: res?.data,
        });
      }
    } catch (error) {
      dispatch({
        type: "Excel_fail",
        payload: error,
      });
    }
  };

  // AddUpdateAssortment API
  const addUpdateFixtureAction = async (assortmentData, tokenVal, history) => {
    try {
      //header
      const config = {
        headers: {
          Authorization: `Bearer ${tokenVal}`,
          "Content-Type": "application/json;charset=utf-8",
          "Access-Control-Allow-Origin": "*",
          "cache-control": "no-cache",
        },
      };

      //request
      const res = await axios.post(
        `${API_URL_FIXTURE}/AddUpdatePlanoGramFixtures`,
        assortmentData,
        config
      );

      //dispatch
      if (res?.request.status === 200) {
        dispatch({
          type: "Add_success",
          payload: res?.data,
        });
      }
      alert(res?.data);
      history.push("/fixtures");

    } catch (error) {
      dispatch({
        type: "Add_fail",
        payload: error,
      });
      alert(error.message);
    }
  };

  // DeleteAssortment API
  const deleteFixtureAction = async ({ f, i, j }, tokenVal) => {
    try {
      //header
      const config = {
        headers: {
          Authorization: `Bearer ${tokenVal}`,
          "Content-Type": "application/json;charset=utf-8",
          "Access-Control-Allow-Origin": "*",
          "cache-control": "no-cache",
        },
      };

      const res = await axios.get(
        `${API_URL_FIXTURE}/DeletePlanogramsFixture?PRD_NBR_KEY=${f}&FIXTURE_KEY=${i}&POG_KEY=${j}`, config
      );

      if (res?.request.status === 200) {
        dispatch({
          type: "Delete_success",
          payload: res?.data,
        });
      }

      window.location.href = "/fixtures";
    } catch (error) {
      dispatch({
        type: "Delete_fail",
        payload: error,
      });
    }
  };

  // GetAssortmentById API
  const getSingleFixtureAction = async ({ f, i, j }, tokenVal) => {
    try {
      //header
      const config = {
        headers: {
          Authorization: `Bearer ${tokenVal}`,
          "Content-Type": "application/json;charset=utf-8",
          "Access-Control-Allow-Origin": "*",
          "cache-control": "no-cache",
        },
      };

      const res = await axios.get(
        `${API_URL_FIXTURE}/GetPlanogramsFixtureById?PRD_NBR_KEY=${f}&FIXTURE_KEY=${i}&POG_KEY=${j}`, config
      );

      if (res?.request.status === 200) {
        dispatch({
          type: "Single_success",
          payload: res?.data,
        });
      }
    } catch (error) {
      dispatch({
        type: "Single_fail",
        payload: error,
      });
    }
  };

  // AddUpdateAssortment API
  const submitAssortmentPlanogramAction = async (assortmentData, tokenVal, history) => {
    try {
      //header
      const config = {
        headers: {
          Authorization: `Bearer ${tokenVal}`,
          "Content-Type": "application/json;charset=utf-8",
          "Access-Control-Allow-Origin": "*",
          "cache-control": "no-cache",
        },
      };

      //request
      const res = await axios.post(
        `${API_URL_FIXTURE}/AssortmentPlanogramMapping`,
        assortmentData,
        config
      );

      //dispatch
      if (res?.request.status === 200) {
        dispatch({
          type: "SubmitPl_success",
          payload: res?.data,
        });
      }
      alert(res?.data);
      history.push("/view-planogram");

    } catch (error) {
      dispatch({
        type: "SubmitPl_fail",
        payload: error,
      });
      alert(error.message);
    }
  };

  // AddUpdateAssortment API
  const saveAssortmentPlanogramAction = async (assortmentData, tokenVal, history) => {
    try {
      //header
      const config = {
        headers: {
          Authorization: `Bearer ${tokenVal}`,
          "Content-Type": "application/json;charset=utf-8",
          "Access-Control-Allow-Origin": "*",
          "cache-control": "no-cache",
        },
      };

      //request
      const res = await axios.post(
        `${API_URL_FIXTURE}/AssortmentPlanogramSave`,
        assortmentData,
        config
      );

      //dispatch
      if (res?.request.status === 200) {
        dispatch({
          type: "savePl_success",
          payload: res?.data,
        });
      }
      alert(res?.data);
      history.push("/view-planogram");

    } catch (error) {
      dispatch({
        type: "savePl_fail",
        payload: error,
      });
      alert(error.message);
    }
  };

  // GetAllAssortment API
  const fetchAssortPlanogramAction = async (tokenVal) => {
    try {
      //header
      const config = {
        headers: {
          Authorization: `Bearer ${tokenVal}`,
          "Content-Type": "application/json;charset=utf-8",
          "Access-Control-Allow-Origin": "*",
          "cache-control": "no-cache",
        },
      };

      const res = await axios.get(
        `${API_URL_FIXTURE}/GetAssortmentPlanogramsHierarchy`, config
      );

      if (res?.request.status === 200) {
        dispatch({
          type: "FetchPl_success",
          payload: res?.data,
        });
      }
    } catch (error) {
      dispatch({
        type: "FetchPl_fail",
        payload: error,
      });
    }
  };

  // GetAllAssortment API
  const fetchOnlyPlanogramAction = async (tokenVal) => {
    try {
      //header
      const config = {
        headers: {
          Authorization: `Bearer ${tokenVal}`,
          "Content-Type": "application/json;charset=utf-8",
          "Access-Control-Allow-Origin": "*",
          "cache-control": "no-cache",
        },
      };

      const res = await axios.get(
        `${API_URL_FIXTURE}/GetUnmappedPlanograms`, config
      );

      if (res?.request.status === 200) {
        dispatch({
          type: "FetchOn_success",
          payload: res?.data,
        });
      }
    } catch (error) {
      dispatch({
        type: "FetchOn_fail",
        payload: error,
      });
    }
  };

  // DeleteAssortment API
  const deletePlanogramAction = async ({ f, i, j }, tokenVal) => {
    try {
      //header
      const config = {
        headers: {
          Authorization: `Bearer ${tokenVal}`,
          "Content-Type": "application/json;charset=utf-8",
          "Access-Control-Allow-Origin": "*",
          "cache-control": "no-cache",
        },
      };

      const res = await axios.get(
        `${API_URL_FIXTURE}/DeleteAssortmentPlanogramsHierarchy?AssortmentId=${f}&Assortment_Sub_Id=${i}&Pog_key=${j}`, config
      );

      if (res?.request.status === 200) {
        dispatch({
          type: "DeletePl_success",
          payload: res?.data,
        });
      }

      alert(res?.data);
      fetchAssortPlanogramAction(tokenVal);
      // window.location.href = "/view-planogram";
    } catch (error) {
      dispatch({
        type: "DeletePl_fail",
        payload: error,
      });
    }
  };

  // GetAssortmentById API
  const getSinglePlanogramAction = async ({ f, i, j }, tokenVal) => {
    try {
      //header
      const config = {
        headers: {
          Authorization: `Bearer ${tokenVal}`,
          "Content-Type": "application/json;charset=utf-8",
          "Access-Control-Allow-Origin": "*",
          "cache-control": "no-cache",
        },
      };

      const res = await axios.get(
        `${API_URL_FIXTURE}/GetAssortmentPlanogramsHierarchyById?AssortmentId=${f}&Assortment_Sub_Id=${i}&Pog_key=${j}`, config
      );

      if (res?.request.status === 200) {
        dispatch({
          type: "SinglePl_success",
          payload: res?.data,
        });
      }
    } catch (error) {
      dispatch({
        type: "SinglePl_fail",
        payload: error,
      });
    }
  };

  return (
    <fixtureContext.Provider
      value={{
        planogram: state?.planogram,
        error: state?.error,
        loading: state?.loading,
        fetchExcelFixtureAction,
        addUpdateFixtureAction,
        deleteFixtureAction,
        getSingleFixtureAction,
        submitAssortmentPlanogramAction,
        saveAssortmentPlanogramAction,
        fetchAssortPlanogramAction,
        fetchOnlyPlanogramAction,
        deletePlanogramAction,
        getSinglePlanogramAction,
        fixtSingleRow: state?.fixtSingleRow,
        rowdelfixt: state?.rowdelfixt,
        assortPlano: state?.assortPlano,
        getplano: state?.getplano,
        onlyplano: state?.onlyplano,
        planoSingleRow: state?.planoSingleRow,
        rowdelplano: state?.rowdelplano,
        planogFix: state?.planogFix,
        savePlanog: state?.savePlanog
      }}
    >
      {children}
    </fixtureContext.Provider>
  );
};
